import { render } from "./post_status_form.vue?vue&type=template&id=43a4f43e"
import script from "./post_status_form.js?vue&type=script&lang=js"
export * from "./post_status_form.js?vue&type=script&lang=js"

import "./post_status_form.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__